import { ArrowUpward, ArrowDownward } from '@mui/icons-material';
import { sortOrder } from '~/types/enum';
import { HEADER_WIDTH } from '~/views/Admin/Admin.constant';
import {
  cell,
  SORT_ICON_STYLE,
} from '~/components/Admin/ResourceTable/ResourceTable.style';
import { TSort } from '~/types/common.type';
// import { TInternetSearchCondition } from '~/store/internetResource/internetResource.type';

type TProps = {
  data: { title: string; property: string };
  index: number;
  sort: TSort<string>;
  handleSort: (property: string) => void;
};

const NOT_SORT_LIST = ['edit'];

export const InternetTableHeaderCell = ({
  data,
  index,
  sort,
  handleSort,
}: TProps) => {
  if (data.property === 'checkbox') {
    return null;
  }
  return (
    <cell.Container sx={{ ...HEADER_WIDTH(index + 1, 'InternetResource') }}>
      <cell.HeaderContent onClick={() => handleSort(data.property)}>
        {data.title}
        {!NOT_SORT_LIST.includes(data.property) && (
          <>
            {sort.property === data.property &&
              sort.order === sortOrder.ASC && (
                <ArrowUpward
                  sx={{
                    ...SORT_ICON_STYLE(true),
                  }}
                />
              )}
            {sort.property === data.property &&
              sort.order === sortOrder.DESC && (
                <ArrowDownward
                  sx={{
                    ...SORT_ICON_STYLE(true),
                  }}
                />
              )}
            {sort.property !== data.property && (
              <ArrowUpward
                sx={{
                  ...SORT_ICON_STYLE(false),
                }}
              />
            )}
          </>
        )}
      </cell.HeaderContent>
    </cell.Container>
  );
};
